import "./App.css";

import React from "react";

import Welcome from "./components/Welcome";
import AlertComponent from "./components/public/Alert";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import LimitedStep1 from "./components/LimitedStep1";
import NotFoundPage from "./components/public/NotFoundPage";
import AnonimStep1 from "./components/AnonimStep1";
import LimitAndPaymentInformation from "./components/LimitAndPaymentInformation";
import Acceptance from "./components/Acceptance";
import Kvkk from "./components/Kvkk";
import Documents from "./components/Documents";
import Success from "./components/Success";
import Loading from "./components/public/Loading";
import Unsuccess from "./components/Unsuccess";
import Waiting from "./components/Waiting";
import CustomerQR from "./components/CustomerQR";
import { BottomNavigation } from "@material-ui/core";
import UnauthorizedPage from "./components/public/UnauthorizedPage";
import EasycepStep1 from "./components/EasycepStep1";
import PlatformWaiting from "./components/PlatformWaiting";


function App() {
  const store = configureStore();
  return (
    <Provider store={store}>
      
      <Loading />
      <BrowserRouter>
        <Switch>
          <Route exact path={["/"]} component={Welcome} />
          <Route exact path={"/:uuid/limitedStep1"} component={LimitedStep1} />
          <Route exact path={"/:uuid/easycepStep1"} component={EasycepStep1} />
          <Route exact path={"/anonimStep1"} component={AnonimStep1} />
          <Route
            exact
            path={"/:uuid/limitAndPaymentInformation"}
            component={LimitAndPaymentInformation}
          />
          <Route exact path={"/:uuid/acceptance"} component={Acceptance} />
          <Route exact path={"/:uuid/kvkk"} component={Kvkk} />
          <Route exact path={"/:uuid/documents"} component={Documents} />
          <Route exact path={"/:uuid/success"} component={Success} />
          <Route exact path={["/:uuid/waiting","/timeout"]} component={Waiting} />
          <Route exact path={["/:uuid/platform-waiting"]} component={PlatformWaiting} />
          <Route exact path={["/:uuid/unsuccess","/unsuccess"]} component={Unsuccess} />
          <Route exact path={["/:uuid/customerQR","/customerQR"]} component={CustomerQR} />
          <Route exact path={"/unauthorized"} component={UnauthorizedPage} />
          <Route exact component={NotFoundPage} /> 
        </Switch>
      </BrowserRouter>
      
    </Provider>
  );
}


export default App;
